import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const BAR_GRAPH_SCHEMA = Object.freeze({
  HIGHLIGHT: null,
  BASELINE: null,
  QUANTITY: null,
});
export const RECORD = generateSchema(BAR_GRAPH_SCHEMA);
export const KEYS: any = generateKeys(BAR_GRAPH_SCHEMA);

export class BarGraph extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get highlight(): number {
    return this.get(KEYS.HIGHLIGHT);
  }

  get baseline(): number {
    return this.get(KEYS.BASELINE);
  }

  get quantity(): number {
    return this.get(KEYS.QUANTITY);
  }
}
